export const setCurrentPage = (data) => ({
  type: "SET_CURRENT_PAGE",
  payload: data,
});

export const setOrderObject = (data) => ({
  type: "SET_ORDER_OBJECT",
  payload: data,
});

export const setInstructions = (data) => ({
  type: "SET_INSTRUCTIONS",
  payload: data,
});

export const setDoOverCount = (data) => ({
  type: "SET_DO_OOVER_COUNT",
  payload: data,
});

export const setStarch = (data) => ({
  type: "SET_STARCH",
  payload: data,
});

export const setCrease = (data) => ({
  type: "SET_CREASE",
  payload: data,
});

export const setBlanket = (data) => ({
  type: "SET_BLANKET",
  payload: data,
});

export const setComforter = (data) => ({
  type: "SET_COMFORTER",
  payload: data,
});

export const setAmount = (data) => ({
  type: "SET_AMOUNT",
  payload: data,
});

export const setTermAndCondition = (data) => ({
  type: "SET_TERMS_AND_CONDITIONS",
  payload: data,
});

export const setTableCloth = (data) => ({
  type: "SET_TABLECLOTH",
  payload: data,
});

export const setNumberOfItems = (data) => ({
  type: "SET_NUMBER_OF_ITEMS",
  payload: data,
});

export const setTipIn = (data) => ({
  type: "SET_TIP_IN",
  payload: data,
});

export const setOrderResponse = (data) => ({
  type: "SET_ORDER_RESPONSE",
  payload: data,
});

export const setCustomerOrdersResponse = (data) => ({
  type: "SET_CUSTOMER_ORDERS_RESPONSE",
  payload: data,
});

export const setSortKey = (data) => ({
  type: "SET_SORT_KEY",
  payload: data,
});

export const setSearch = (data) => ({
  type: "SET_SEARCH",
  payload: data,
});

export const setSortClass = (data) => ({
  type: "SET_SORT_CLASS",
  payload: data,
});

export const setOrderSummary = (data) => ({
  type: "SET_ORDER_SUMMARY",
  payload: data,
});

export const setCancelOrderModal = (data) => ({
  type: "SET_CANCEL_ORDER_MODAL",
  payload: data,
});

export const setCancelOrder = (data) => ({
  type: "SET_CANCEL_ORDER",
  payload: data,
});

export const setCancelOrderResponse = (data) => ({
  type: "SET_CANCEL_ORDER_RESPONSE",
  payload: data,
});

export const setTipDetailsResponse = (data) => ({
  type: "SET_TIP_DETAILS_RESPONSE",
  payload: data,
});

export const setPriceListing = (data) => ({
  type: "SET_PRICES",
  payload: data,
});

export const setClassCodeList = (data) => ({
  type: "SET_CLASS_CODES",
  payload: data,
});

export const setTipValue = (data) => ({
  type: "SET_TIP_VALUE",
  payload: data,
});

export const setOtherTipValue = (data) => ({
  type: "SET_OTHER_TIP_VALUE",
  payload: data,
});

export const setOtherTipSelected = (data) => ({
  type: "SET_OTHER_TIP_SELECTED",
  payload: data,
  
});

export const setLocation = (data) => ({
  type: "SET_LOCATION",
  payload: data,
});

export const setClassCodes = (data) => ({
  type: "SET_CLASS_CODES",
  payload: data,
});

export const setServiceRates = (data) => ({
  type: "SET_SERVICE_RATES",
  payload: data,
});

export const setSelectedServices = (services) => ({
  type: "SET_SELECTED_SERVICES",
  payload: services,
});

export const setTipDetails = (data) => ({
  type: "SET_TIP_DETAILS",
  payload: data,
});

export const setPaymentAuthorizationResponse = (data) => ({
  type: "SET_PAYMENT_AUTHORIZATION_RESPONSE",
  payload: data,
});

const token = localStorage.getItem("Token");
// const rootURL = "https://pndapi.drycleandepotdelivers.com/";
export const postWebOrders = (viewModel, token) => {
  return async function (dispatch) {
    try {

      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/order/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify(viewModel),
          redirect: "follow", // Added to handle redirects
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("API Error Response:", errorData);
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      dispatch(setOrderResponse(data));
      return data;
    } catch (error) {
      console.error("Error posting web orders:", error);
      dispatch(
        setOrderResponse({
          HasErrors: true,
          ResultMessages: [{ Message: error.message }],
        })
      );
      throw error;
    }
  };
};

export const postSearchCustomerOrders = (viewModel, token) => {
  return async function (dispatch) {
    const { page, page_size, search } = viewModel;
    const offset = (page - 1) * page_size;
    return await fetch(
      `${
        process.env.REACT_APP_DEV_PYTHON_URL
      }/order?limit=${page_size}&offset=${offset}${
        search ? `&search=${search}` : ""
      }`,
      {
        method: "GET",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          Authorization: "Token " + localStorage.getItem("Token"),
          "Content-Type": "application/json",
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        dispatch(setCustomerOrdersResponse(data));
      })
      .catch((err) => console.log(err));
  };
};

export const postSearchedCustomerOrders = (viewModel, token) => {
  return async function (dispatch) {
    return await postData(
      `${process.env.REACT_APP_ROOT_URL}/Order/PostSearchedCustomerOrders`,
      viewModel,
      token
    ).then((data) => {
      dispatch(setCustomerOrdersResponse(data));
    });
  };
};

export const fetchOrderDetails = (customerId, token) => {
  return async function (dispatch) {
    return await fetch(
      `${
        process.env.REACT_APP_ROOT_URL
      }/Order?custId=${customerId}&orderId=${0}`,
      {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          Authorization: token,
          "Content-Type": "application/json, charset=utf-8",
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          // dispatch(setOrderObject(result));
        },
        (error) => {
          console.error(error);
        }
      );
  };
};

// export const getCancelOrder = (orderId, token) => {
//   return async function (dispatch) {
//     return await fetch(
//       `${process.env.REACT_APP_ROOT_URL}/Order/GetCancelOrder?cancelSource=Customer&orderNo=${orderId}&orderOperation=Cancel`,
//       {
//         method: "GET",
//         mode: "cors",
//         headers: new Headers({
//           Accept: "application/json, text/plain, */*",
//           Authorization: token,
//           "Content-Type": "application/json",
//         }),
//       }
//     )
//       .then((res) => res.json())
//       .then(
//         (result) => {
//           dispatch(setCancelOrderResponse(result));
//         },
//         (error) => {
//           console.error(error);
//         }
//       );
//   };
// };

export const fetchOrderSummary = (customerId, token, orderNo) => {
  return async function (dispatch) {
    const token = localStorage.getItem("Token");
    
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/order/order-details?order_id=${orderNo}`,
        {
          method: "GET",
          mode: "cors",
          headers: new Headers({
            Accept: "application/json, text/plain, */*",
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          }),
        }
      );
      const data = await response.json();
      dispatch(setOrderSummary(data));
      return data;
    } catch (error) {
      console.error("Error fetching tip details:", error);
      dispatch(setTipDetailsResponse(null));
      throw error;
    }
  };
};

export const fetchTipDetails = () => {
  return async function (dispatch) {
    const token = localStorage.getItem("Token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/financials/tipping-percentage/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch(setTipDetailsResponse(data));
      return data;
    } catch (error) {
      console.error("Error fetching tip details:", error);
      dispatch(setTipDetailsResponse(null));
      throw error;
    }
  };
};

export const getPriceListing = () => {
  return async function (dispatch) {
    return await fetch(
      `${process.env.REACT_APP_ROOT_URL}/ContentManagement/GetPriceListing`,
      {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          // Authorization: token,
          "Content-Type": "application/json, charset=utf-8",
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          dispatch(setPriceListing(result?.priceListing));
        },
        (error) => {
          console.error(error);
        }
      );
  };
};

export const fetchClassCodes = () => {
  return async function (dispatch) {
    const token = localStorage.getItem("Token");
  if (!token) {
      console.error("Token not available yet.");
      return;
    }
    return await fetch(
      `${process.env.REACT_APP_DEV_PYTHON_URL}/invoice/class-code/?franchise_id=${process.env.REACT_APP_FRANCHISE_ID}`,
      {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          Authorization: `Token ${token}`,
          "Content-Type": "application/json, charset=utf-8",
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          dispatch(setClassCodes(result));
          // Extract class code IDs and fetch service rates
          if (result.results && result.results.length > 0) {
           const classCodeIds = result.results
              .filter(item => item.class_code === 'Z')
              .map(item => item.id);

            dispatch(fetchServiceRates(classCodeIds));
          }
        },
        (error) => {
          console.error(error);
        }
      );
  };
};

export const fetchServiceRates = (classCodeIds) => {
  return async function (dispatch) {
    const token = localStorage.getItem("Token");

     if (!token) {
      console.error("Token not available yet.");
      return;
    }

    return await fetch(
      `${process.env.REACT_APP_DEV_PYTHON_URL}/invoice/service-rates/?franchise_id=${process.env.REACT_APP_FRANCHISE_ID}&class_code_id=${classCodeIds}&show_customer=true&limit=1000&offset=0`,
      {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          Authorization: `Token ${token}`,
          "Content-Type": "application/json, charset=utf-8",
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          dispatch(setServiceRates(result));
        },
        (error) => {
          console.error(error);
        }
      );
  };
};
export const getClassListUrl = () => {
  return async function (dispatch) {
    const token = localStorage.getItem("Token");
  if (!token) {
      console.error("Token not available yet.");
      return;
    }
    return await fetch(
      `${process.env.REACT_APP_DEV_PYTHON_URL}/invoice/class-code/?franchise_id=${process.env.REACT_APP_FRANCHISE_ID}`,
      {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          dispatch(setClassCodeList(result?.results));
        },
        (error) => {
          console.error(error);
        }
      );
  };
};

export const authorizePayment = (
  totalAmount,
  cardId,
  orderId,
  tipAmount,
  token
) => {
  return async function (dispatch) {
    return await fetch(
      `${process.env.REACT_APP_DEV_PYTHON_URL}/api/financials/square/authorize-payment/?total_amount=${totalAmount}&card_id=${cardId}&order_id=${orderId}&tip_amount=${tipAmount}`,
      {
        method: "POST",
        headers: new Headers({
          Accept: "application/json, text/plain, */*",
          Authorization: "Token " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        dispatch(setPaymentAuthorizationResponse(data));
        return data;
      })
      .catch((error) => {
        console.error("Payment authorization error:", error);
        throw error;
      });
  };
};

export const getCancelOrder = (orderId, token) => {
  return async function (dispatch) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/order/cancel/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify({ order_id: orderId, order_cancel_reason: "Services not available" }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch(setCancelOrderResponse(data));
      return data;
    } catch (error) {
      console.error("Error cancelling order:", error);
      throw error;
    }
  };
};

const postData = async (url = "", data = {}, token) => {
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
      Authorization: token,
    },
    body: JSON.stringify(data),
  });
  return response.json(); // parses JSON response into native JavaScript objects
};
